export default "__VITE_ASSET__npwSpQov__"